export default __webpack_public_path__ + "static/media/Audit.dac9685d.webp";